// removed by extract-text-webpack-plugin
module.exports = {"numCol":"index__numCol___3scsz","actionCol":"index__actionCol___20CYz","row":"index__row___2O-5J","mainCol":"index__mainCol___sC_pY","error-row":"index__error-row___2ZDND"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Criterion/index.less
// module id = 1031
// module chunks = 3